AFRAME.registerComponent('search-handler', {
    schema: {

    },
    init: function () {
        this.inputHtml = this.el.querySelector('#ticker-search-input')
        this.inputAframe = this.el.querySelector('#search-input-element')
        this.foundCompaniesList = []
        this.foundCompaniesListContainer = this.el.querySelector('.found-companies-list-container')
        this.foundCompaniesListContent = this.el.querySelector('.found-companies-list-content')
        this.foundCompaniesBg = this.el.querySelector('.found-companies-bg')

        this.isDropdownPulsing = false
        this.pulseAnimationId = null
        this.pulseStartTime = 0
        this.hasDropdownResults = false
        this.clearButton = this.el.querySelector('#search-clear-button')

        this.themeMode = 'Dark';
        try {
            if (typeof getCacheItem === 'function') {
                const mainSettings = getCacheItem('mainSettings');
                if (mainSettings && mainSettings.themeMode) {
                    this.themeMode = mainSettings.themeMode;
                }
            }
        } catch (e) { }

        window.addEventListener('theme-changed', (e) => {
            if (e.detail && e.detail.themeMode) {
                this.themeMode = e.detail.themeMode;
                this.updateCenterPanelTheme();
            }
        });
        this.updateCenterPanelTheme();

        this.el.sceneEl.addEventListener('chart-settings-changed', (e) => {
            if (!e.detail) return;
            let { type, value } = e.detail;

            if (type === 'chartType') {
                type = 'type';
            }

            const centerChart = document.querySelector('#center-stock-chart');
            if (centerChart) {
                centerChart.setAttribute('tradingview-universal-chart', type, value);
            }
        });
        this._onSceneClick = (e) => {
            const clickedEl = e.target
            const searchContainer = this.el
            const isInsideSearch = searchContainer.contains(clickedEl) || clickedEl === searchContainer

            if (!isInsideSearch && this.hasDropdownResults && !this.isDropdownPulsing) {
                this.startPulsingGlow()
            }
        }
        this.el.sceneEl.addEventListener('click', this._onSceneClick)

        this.setListeners()
    },

    clearSearch: function () {
        const placeholderText = 'Search tickers or company...';
        if (this.inputHtml) {
            this.inputHtml.value = placeholderText;
            this.inputHtml.classList.add(`updated-${new Date().getTime()}`);
            this.inputHtml.blur();
        }
        if (this.clearButton) {
            this.clearButton.setAttribute('visible', 'false');
        }
        this.hideDropdown();
        this.stopPulsingGlow();
        if (this.inputHtml) this.inputHtml.dispatchEvent(new Event('input'));
    },

    showDropdown: function () {
        this.hasDropdownResults = true
        this.foundCompaniesListContainer.setAttribute('visible', 'true')
        this.foundCompaniesListContainer.setAttribute('position', '0 0 0')
        this.el.sceneEl.emit('search-dropdown-toggled', { visible: true })
    },

    hideDropdown: function () {
        this.hasDropdownResults = false
        this.foundCompaniesListContainer.setAttribute('visible', 'false')
        this.foundCompaniesListContainer.setAttribute('position', '0 10.0 0')
        this.el.sceneEl.emit('search-dropdown-toggled', { visible: false })
    },

    updateCenterPanelTheme: function () {
        if (this.foundCompaniesListContainer && this.foundCompaniesListContainer.getAttribute('visible')) {
            this.displayCompaniesList();
        }
        
        this.adjustSizesForCurrentTheme();

        if (this.clearButton) {
            const textEl = this.clearButton.querySelector('a-troika-text');
            if (textEl) {
                textEl.setAttribute('color', this.themeMode === 'Light' ? '#14141C' : '#FFFFFF');
            }
        }
    },
    
    adjustSizesForCurrentTheme: function () {
        if (this.foundCompaniesListContent) {
            if (this.themeMode === 'Light') {
                this.foundCompaniesListContent.setAttribute('position', '-0.05 -0.085 -0.035');
                this.foundCompaniesListContent.setAttribute('scale', '0.985 0.975 1');
            } else {
                this.foundCompaniesListContent.setAttribute('position', '-0.055 -0.085 -0.035');
                this.foundCompaniesListContent.setAttribute('scale', '0.995 0.985 1');
            }
        }
    },
    

    setListeners: function () {
        const placeholderText = 'Search tickers or company...'
        const apiURL = 'https://api.palosverdestech.com/'

        this.inputHtml.addEventListener('input', async (e) => {
            const query = e.target.value.trim();

            if (query.length > 0 && query !== placeholderText) {
                if (this.clearButton) this.clearButton.setAttribute('visible', 'true');
                try {
                    const response = await fetch(`${apiURL}/tickers/search/${encodeURIComponent(query)}`);

                    if (!response.ok) {
                        throw new Error(`Search failed: ${response.status} ${response.statusText}`);
                    }

                    const data = await response.json();
                    const currentResults = data.results || [];
                    this.foundCompaniesList = currentResults.slice(0, 5);
                    if (this.foundCompaniesList.length) {
                        this.showDropdown()
                        this.displayCompaniesList()
                    } else {
                        this.hideDropdown()
                    }

                } catch (error) {
                    console.error('Ticker search error:', error);
                }
            } else {
                if (this.clearButton) this.clearButton.setAttribute('visible', 'false');
                this.hideDropdown()
                this.stopPulsingGlow()
            }
        })
        this.inputHtml.addEventListener('focus', (e) => {
            const currentText = e.target.value
            if (currentText === placeholderText) {
                this.inputHtml.value = ''
            }
            if (currentText.length && currentText !== placeholderText) {
                if (this.clearButton) this.clearButton.setAttribute('visible', 'true');
                if (this.foundCompaniesList.length) {
                    this.showDropdown()
                }
            } else {
                this.hideDropdown()
            }
            this.stopPulsingGlow()
        })
        this.inputHtml.addEventListener('blur', (e) => {
            this.startPulsingGlow()
            const currentText = e.target.value
            if (currentText === '') {
                this.inputHtml.value = placeholderText
                this.inputHtml.classList.add(`updated-${new Date().getTime()}`)
            }
        })

        if (this.inputAframe) {
            this.inputAframe.addEventListener('click', () => {
                if (this.inputHtml.value === placeholderText) {
                    this.inputHtml.value = ''
                    this.inputHtml.classList.add(`updated-${new Date().getTime()}`)
                }
                this.stopPulsingGlow()
            })
        }

        if (this.clearButton) {
            const textEl = this.clearButton.querySelector('a-troika-text');
            this.clearButton.addEventListener('mouseenter', () => {
                if (textEl) textEl.setAttribute('font-size', '0.07');
            });
            this.clearButton.addEventListener('mouseleave', () => {
                if (textEl) textEl.setAttribute('font-size', '0.06');
            });
            this.clearButton.addEventListener('click', () => {
                this.clearSearch();
            });
        }

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') this.selectFirstCompanyFromList()
        });
    },

    selectFirstCompanyFromList: function () {
        const isListShown = this.foundCompaniesListContainer.getAttribute('visible')
        const isCompaniesFound = this.foundCompaniesList.length > 0
        if (isListShown && isCompaniesFound) {
            this.openTicket(this.foundCompaniesList[0])
        }
    },

    displayCompaniesList: function () {
        const self = this

        if (!this.foundCompaniesListContent) return
        this.foundCompaniesListContent.innerHTML = ''

        const bg = document.createElement('a-rounded-plane');
        const listWidth = 1.35;

        const isLight = this.themeMode === 'Light';
        const bgColor = isLight ? '#FFFFFF' : '#333';
        const textColor = isLight ? '#14141C' : '#FFFFFF';

        bg.setAttribute('width', listWidth + 0.01);
        bg.setAttribute('height', this.foundCompaniesList.length * 0.15 + 0.01);
        bg.setAttribute('radius', '0.01');
        bg.setAttribute('color', bgColor);
        bg.setAttribute('opacity', '0.8');
        bg.setAttribute('position', `-0.065 0.01 0.05`);
        bg.setAttribute('rotation', `0 180 180`);
        this.foundCompaniesListContent.appendChild(bg);

        this.foundCompaniesBg.setAttribute('scale', `0.0147 ${0.01 * (this.foundCompaniesList.length / 5)} 0.01`)
        this.foundCompaniesBg.setAttribute('position', `0.555 -0.075 0.019`)
        this.foundCompaniesBg.setAttribute('visible', !!this.foundCompaniesList.length)


        this.foundCompaniesList.forEach((item, index) => {
            const y = - index * 0.15 - 0.075
            createCompanyRow(item, y)
        })



        function createCompanyRow(item, positionY) {
            const companyRow = document.createElement('a-entity');
            companyRow.setAttribute('position', `0 ${positionY} 0.05`);
            self.foundCompaniesListContent.appendChild(companyRow)

            const tickerElement = document.createElement('a-text');
            tickerElement.setAttribute('value', item && item.ticker_symbol ? item.ticker_symbol : '');
            tickerElement.setAttribute('scale', '0.2 0.2 0.2');
            tickerElement.setAttribute('baseline', 'center');
            tickerElement.setAttribute('align', 'left');
            tickerElement.setAttribute('anchor', 'left');
            tickerElement.setAttribute('color', textColor);
            tickerElement.setAttribute('position', `0 0 0.012`)
            companyRow.appendChild(tickerElement)

            const companyElement = document.createElement('a-text');
            companyElement.setAttribute('value', item && item.company_name ? item.company_name : '');
            companyElement.setAttribute('scale', '0.2 0.2 0.2');
            companyElement.setAttribute('width', '5.8');
            companyElement.setAttribute('wrap-count', '46.4');
            companyElement.setAttribute('baseline', 'center');
            companyElement.setAttribute('align', 'left');
            companyElement.setAttribute('anchor', 'left');
            companyElement.setAttribute('color', textColor);
            companyElement.setAttribute('position', `0.2 0 0.012`)
            companyRow.appendChild(companyElement)

            const bgClickable = document.createElement('a-plane');
            bgClickable.setAttribute('width', `1.35`)
            bgClickable.setAttribute('height', `0.15`)
            bgClickable.setAttribute('color', `#666`)
            bgClickable.setAttribute('opacity', `0`)
            bgClickable.setAttribute('data-raycastable', ``)
            bgClickable.setAttribute('position', `0.615 0 0.011`)
            companyRow.appendChild(bgClickable)

            const hoverColor = isLight ? '#3636E3' : '#666';
            const hoverOpacity = isLight ? '0.15' : '1';

            bgClickable.addEventListener('mouseenter', () => {
                bgClickable.setAttribute('color', hoverColor);
                bgClickable.setAttribute('animation__opacity', {
                    property: 'opacity',
                    to: hoverOpacity,
                    dur: 200,
                    easing: 'easeInOutQuad'
                });
            });
            bgClickable.addEventListener('mouseleave', () => {
                bgClickable.setAttribute('animation__opacity', {
                    property: 'opacity',
                    to: '0',
                    dur: 200,
                    easing: 'easeInOutQuad'
                });
            });
            bgClickable.addEventListener('click', () => {
                self.openTicket(item);
            });

        }
    },

    openTicket: async function (item) {
        this.hideDropdown()
        this.stopPulsingGlow()

        let volume = null

        if (item.ticker_symbol) {
            if(window.gtag) gtag('event', `VR_TopNav_Search`, {ticker: item.ticker_symbol});

            try {
                volume = await this.fetchVolumeData(item.ticker_symbol);
            } catch (err) {
                console.error('Error fetching ticket data:', err);
            }
        }
        
        const stock = {
            ticker: item.ticker_symbol,
            primary_exchange: item.exchange,
            daypart_relative_volume_percentage: volume,
            tickerDetails: {
                name: item.company_name
            }
        }
        
        this.openStockChart(stock);
    },

    fetchVolumeData: async function (tickerSymbol) {
        const protocol = window.location.protocol;
        const hostname = window.location.host;
        const proxyBaseURL = `${protocol}//${hostname}/proxy-pvtech?url=`;
        const baseURLAPI = 'https://api.palosverdestech.com/tickers/details/metrics/daypart-rvol/';
        const useProxy = false
        const url = useProxy ? `${proxyBaseURL}${encodeURIComponent(baseURLAPI + tickerSymbol)}` : (baseURLAPI + tickerSymbol);

        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

        const jsonData = await response.json();
        if (jsonData) {
            return jsonData.daypart_relative_volume_percentage || null;
        }
        return null
    },

    openStockChart: function (stock) {
        let exchange = stock.primary_exchange || 'Unknown Exchange';
        if (exchange === "New York Stock Exchange") {
            exchange = "NYSE";
        }
        const formattedTicker = `${exchange}:${stock.ticker || 'UNKNOWN'}`;
        if (typeof addTickerNewsToLeftPanel === 'function') {
            addTickerNewsToLeftPanel(formattedTicker);
        }

        const scene = this.el.sceneEl || document.querySelector('a-scene');
        if (scene) {
            scene.emit('stock-selected', stock);
        }
        const searchMode = this.el.components['search-mode'];
        if (searchMode) {
             searchMode.enterSearchMode(stock);
        } else {
             console.error('Search Mode component not found on element');
        }
    },

    startPulsingGlow: function () {
        if (this.isDropdownPulsing) return
        if (!this.foundCompaniesBg) return

        const bgObject = this.foundCompaniesBg.object3D
        if (!bgObject) {
            this.foundCompaniesBg.addEventListener('model-loaded', () => {
                if (!this.isDropdownPulsing) {
                    this.startPulsingGlow()
                }
            }, { once: true })
            return
        }

        this.isDropdownPulsing = true
        this.pulseStartTime = performance.now()

        if (!this._originalMaterials) {
            this._originalMaterials = new Map()
        }

        let meshCount = 0
        bgObject.traverse((node) => {
            if (node.isMesh && node.material && node.name === 'Plane001_1') {
                meshCount++
                const mats = Array.isArray(node.material) ? node.material : [node.material]
                const newMats = mats.map((mat, idx) => {
                    const key = `${node.uuid}_${idx}`
                    if (!this._originalMaterials.has(key)) {
                        this._originalMaterials.set(key, { 
                            node, 
                            idx, 
                            material: mat.clone(),
                            toneMapped: mat.toneMapped,
                            transparent: mat.transparent,
                            depthWrite: mat.depthWrite
                        })
                    }
                    if (!mat.emissive) {
                        const stdMat = new THREE.MeshStandardMaterial({
                            color: mat.color ? mat.color.clone() : new THREE.Color(0x3636E3),
                            roughness: 0.1,
                            metalness: 0.1,
                            transparent: true,
                            opacity: mat.opacity,
                            side: mat.side,
                        })
                        if (mat.map) stdMat.map = mat.map
                        stdMat.emissive = new THREE.Color(0x3636E3)
                        stdMat.emissiveIntensity = 0
                        stdMat.toneMapped = false
                        stdMat.depthWrite = false
                        stdMat.needsUpdate = true
                        return stdMat
                    } else {
                        mat.emissive.set(0x3636E3)
                        mat.emissiveIntensity = 0
                        mat.toneMapped = false
                        mat.transparent = true
                        mat.depthWrite = false 
                        mat.needsUpdate = true
                        return mat
                    }
                })
                node.material = newMats.length === 1 ? newMats[0] : newMats
            }
        })

        const periodMs = 2000
        const self = this

        const meshes = []
        bgObject.traverse((node) => {
            if (node.isMesh && node.material && node.name === 'Plane001_1') {
                meshes.push(node)
            }
        })

        function animate() {
            if (!self.isDropdownPulsing) return

            const elapsed = performance.now() - self.pulseStartTime
            const phase = (elapsed % periodMs) / periodMs
            const intensity = 0.5 * (1 - Math.cos(2 * Math.PI * phase))

            meshes.forEach((node) => {
                const materials = Array.isArray(node.material) ? node.material : [node.material]
                materials.forEach((mat) => {
                    if (mat.emissive) {
                        mat.emissive.setRGB(
                            intensity * 2.0, 
                            intensity * 2.0, 
                            intensity * 15.0
                        )
                        mat.emissiveIntensity = 1.0
                    }
                })
            })

            self.pulseAnimationId = setTimeout(() => animate(), 16)
        }

        this.pulseAnimationId = setTimeout(() => animate(), 16)
    },

    stopPulsingGlow: function () {
        if (!this.isDropdownPulsing) return

        this.isDropdownPulsing = false

        if (this.pulseAnimationId) {
            cancelAnimationFrame(this.pulseAnimationId)
            this.pulseAnimationId = null
        }

        if (this._originalMaterials && this._originalMaterials.size > 0) {
            this._originalMaterials.forEach(({ node, idx, material, toneMapped, transparent, depthWrite }) => {
                if (node && node.material) {
                    if (Array.isArray(node.material)) {
                        node.material[idx] = material
                    } else {
                        node.material = material
                    }
                    node.material.toneMapped = toneMapped
                    node.material.transparent = transparent
                    node.material.depthWrite = depthWrite
                    node.material.needsUpdate = true
                }
            })
            this._originalMaterials.clear()
        } else if (this.foundCompaniesBg && this.foundCompaniesBg.object3D) {
            this.foundCompaniesBg.object3D.traverse((node) => {
                if (node.isMesh && node.material) {
                    const materials = Array.isArray(node.material) ? node.material : [node.material]
                    materials.forEach((mat) => {
                        if (mat.emissive) {
                            mat.emissiveIntensity = 0
                            mat.needsUpdate = true
                        }
                    })
                }
            })
        }
    },

});
